import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "How fast can my business go online?",
    a: "Most shops go live within 2 days. Share your products, logo and contact details — we handle the website, mobile app, payment setup and AI assistant end-to-end.",
  },
  {
    q: "How much does it cost?",
    a: "We have affordable plans designed for Indian businesses. Starter plans begin at ₹9,999 one-time with low monthly maintenance. WhatsApp us for a free quote tailored to your shop or service.",
  },
  {
    q: "Do you support Hindi and regional languages?",
    a: "Yes. Your website, app and AI assistant can speak Hindi, English and major regional languages. Our team also supports you in Hindi over WhatsApp.",
  },
  {
    q: "Will I get payments directly in my bank account?",
    a: "Absolutely. We integrate UPI, cards and wallets — money is settled directly to your verified bank account with full statements in your dashboard.",
  },
  {
    q: "Can I manage everything from my phone?",
    a: "Yes. You get a mobile-first dashboard to manage products, orders, customers and offers from your phone — designed for shop owners, not engineers.",
  },
  {
    q: "What if I don't know anything about websites?",
    a: "Zero tech knowledge needed. Our team sets up everything and trains you in Hindi/English over a WhatsApp call. You just focus on your business.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <p className="uppercase text-xs tracking-[0.24em] text-violet-300 font-semibold">
            FAQ
          </p>
          <h2
            data-testid="faq-heading"
            className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight"
          >
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl glass border border-white/5 px-5 data-[state=open]:border-violet-500/40 transition-all"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display font-semibold text-base sm:text-lg hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed pb-5 text-sm sm:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
